import { MotionContainer, varBounce } from '@aibees/shared/components/animate';
import { CompactLayout } from '@aibees/shared/layouts';
import { RouterLink } from '@aibees/shared/router';
import { Box, Button, Typography } from '@mui/material';
import { m } from 'framer-motion';

type Props = {
  title?: string;
  description?: string;
  redirectTo?: string;
  redirectToTitle?: string;
  onRedirect?: () => void;
};

export default function ErrorView({
  title,
  description,
  redirectTo,
  redirectToTitle,
  onRedirect,
}: Props) {
  return (
    <CompactLayout>
      <MotionContainer display="flex" flexDirection="column" gap={2}>
        <m.div variants={varBounce().in}>
          <Typography variant="h4">{title || 'Error!'}</Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography variant="body1" color="grey.700">
            {description || 'There was an error, please try again later.'}
          </Typography>
        </m.div>

        <Box>
          <Button
            component={RouterLink}
            to={redirectTo || '/'}
            size="large"
            variant="text"
            onClick={onRedirect}
          >
            {redirectToTitle || 'Go to Home'}
          </Button>
        </Box>
      </MotionContainer>
    </CompactLayout>
  );
}
